import "./index.css";
import App from "./App";
import { logError } from "ErrorService";
import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import { ApplicationErrorComponent } from "Components/Errors/ApplicationErrorComponent";
import { initSentry } from "Utils/SentryUtils";

initSentry();

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
  <Sentry.ErrorBoundary
    fallback={errorInfo => (
      <ApplicationErrorComponent error={errorInfo.error} />
    )}
    showDialog={true}
    dialogOptions={{
      lang: "cs",
    }}
  >
    <Sentry.Profiler name="Main">
      <App />
    </Sentry.Profiler>
  </Sentry.ErrorBoundary>,
);

window.addEventListener("error", function (event) {
  logError(event.error);
});

const setVhUnit = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
};
setVhUnit();
window.addEventListener("resize", () => {
  setVhUnit();
});
